import useSWR from "swr";
import { getEnvVariable } from "utilities/env";

const token = getEnvVariable("REACT_APP_GITBOOK_TOKEN");
const spaceId = getEnvVariable("REACT_APP_GITBOOK_SPACE_ID");

export type NewsItem = {
  date: string;
  description: string;
  header: string;
  link?: string;
};

export const useGitbook = () => {
  const useGitbookPageContent = () => {
    return useSWR(
      () =>
        `https://api.gitbook.com/v1/spaces/${spaceId}/content/path/whats-new-ol`,
      (url) =>
        fetch(url, {
          headers: { Authorization: `Bearer ${token}` },
        }).then((r) => {
          if (r.ok) {
            return r.json();
          } else {
            throw r;
          }
        }),
    );
  };

  const parseGitbookContent = (content: any): NewsItem[] => {
    try {
      const parsedContent = JSON.parse(
        content?.document?.nodes?.find(
          ({ type }: { type: string }) => type === "code",
        )?.nodes?.[0]?.nodes?.[0]?.leaves?.[0]?.text,
      );
      return parsedContent?.content;
    } catch (err) {
      return [];
    }
  };

  return {
    parseGitbookContent,
    useGitbookPageContent,
  };
};
